<div class="modal-header">
    <button class="close" aria-label="Close" data-bs-dismiss="modal" type="button" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">{{data.nameDetail?.firstName}} {{data.nameDetail?.middleName}} {{data.nameDetail?.lastName}} {{getValues(data.nameDetail?.customerIndividualNameSuffixTypeId, nameSuffixTypes)}}</h4>
</div>

<div class="modal-body text-center">
    <div class="row">
        <div class="col-sm-6">
            <customer-photo classes="mvd_photo" [customerNumberId]="customerNumberId"></customer-photo>
        </div>
        <div class="col-sm-6" text-center>
            <customer-signature [customerNumberId]="customerNumberId"></customer-signature>
        </div>
    </div>
</div>